// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_2n-1";
export var rateTableServiceLevelDropdown = "_2n-3";
export var rateTableTypeDropdown = "_2n-0";
export var rateTableValueModeDropdown = "_2n-2";